import React, { useState, useEffect } from "react";
//style
import "./styled.css";
//redux
import { connect } from "react-redux";
//components
import Choic from "./choic";
import FormLogin from "./formLogin";
//imgs
import Logo from "../../assets/images/ntt/logo-branco.png";

function Login(props) {
  const [step, setStep] = useState("_a");

  useEffect(() => {
    props.loadingUser()
  }, [])
  return (
    <section className="section-login">
      <div className="div-login">
        {/* <img src={Header} className="img-header" alt="Jornada Cultural, embarque nesta imersão" /> */}
        {step === "_a" && <Choic setStep={setStep} />}
        {step === "_b" && <FormLogin setStep={setStep} />}
        <img src={Logo} className="img-logo" alt="NTT Data" />
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUser: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
